/**
 * SkipLink — UX-023.
 *
 * Visually hidden anchor that becomes visible on keyboard focus and jumps
 * to `#main-content`. First focusable element in `AppLayout`.
 *
 * Contract:
 * - The wrapping layout must provide `<main id="main-content" tabIndex={-1}>`.
 * - `tabIndex={-1}` lets the anchor programmatically focus the main region
 *   after jump without adding it to the natural tab order.
 */

import type { MouseEvent } from "react";

const SKIP_TARGET_ID = "main-content";

export function SkipLink() {
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    const target = document.getElementById(SKIP_TARGET_ID);
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: false });
    // Also update the hash for deep-link parity.
    if (window.location.hash !== `#${SKIP_TARGET_ID}`) {
      window.history.replaceState(null, "", `#${SKIP_TARGET_ID}`);
    }
  };

  return (
    <a
      href={`#${SKIP_TARGET_ID}`}
      onClick={handleClick}
      className={[
        // Off-screen by default.
        "sr-only",
        // Visible on keyboard focus.
        "focus:not-sr-only",
        "focus:fixed",
        "focus:top-3",
        "focus:left-3",
        "focus:z-[100]",
        "focus:px-4",
        "focus:py-2",
        "focus:rounded-md",
        "focus:bg-primary",
        "focus:text-primary-foreground",
        "focus:font-medium",
        "focus:shadow-lg",
        "focus:outline-none",
        "focus:ring-2",
        "focus:ring-ring",
        "focus:ring-offset-2",
      ].join(" ")}
    >
      Pular para o conteúdo
    </a>
  );
}

